<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  data() {
    return { inboxName: '', apiId: '', sender: '', partnerId: '213871' };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    async createChannel() {
      if (!this.inboxName.trim() || !this.apiId) {
        useAlert('Заполните название и api_id SMS.ru');
        return;
      }
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: {
            type: 'smsru',
            phone_number: this.sender || null,
            provider_config: { api_id: this.apiId, sender: this.sender, partner_id: this.partnerId },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(error?.response?.data?.message || 'Не удалось создать источник SMS.ru');
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader
      header-title="СМС через SMS.ru"
      header-content="Источник для отправки/приёма СМС через сервис SMS.ru."
    />
    <form class="flex flex-col flex-wrap mx-0" @submit.prevent="createChannel">
      <div class="flex-shrink-0 flex-grow-0">
        <label>Название инбокса<input v-model="inboxName" type="text" placeholder="Например: СМС SMS.ru" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>api_id<input v-model="apiId" type="text" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Имя отправителя (from)<input v-model="sender" type="text" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Партнёрский ID<input v-model="partnerId" type="text" placeholder="213871" /></label>
      </div>
      <div class="w-full mt-4">
        <NextButton :is-loading="uiFlags.isCreating" type="submit" solid blue label="Создать источник" />
      </div>
    </form>
  </div>
</template>
